import { render } from "./ProjectTile.vue?vue&type=template&id=2fbf127e&scoped=true"
import script from "./ProjectTile.vue?vue&type=script&lang=js"
export * from "./ProjectTile.vue?vue&type=script&lang=js"

import "./ProjectTile.vue?vue&type=style&index=0&id=2fbf127e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbf127e"]])

export default __exports__